export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error('Ошибка при копировании в буфер обмена:', error);
    return false;
  }
}; 